<template>
  <div style="display: inline;">
    <el-form ref="form" size="mini" :model="form" label-width="0px">
      <el-form-item :label="$t('wuliaoBOMmingcheng')" label-width="115px" prop="name" :rules="rules.name">
        <div style="display: flex; align-items: center; justify-content: space-between; padding-right: 100px;">
          <el-input v-model="form.name" type="text" class="input1"></el-input>
          <div style="display: flex; align-items: center;">
            <span style="margin-right: 8px; white-space: nowrap;">{{ $t('sheweimoren' )}}</span>
            <el-switch v-model="form.isDefault"></el-switch>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <yi_cross_select :key="key" :selectTitle="'name'" ref="material" :component="'web_base_matter_list'" :max="1" :ids.sync="materialList" multiple :isInput="true" :isButton="true" :buttonTitle="'tianjiawuliao'" @getItems="getItems"> </yi_cross_select>
      </el-form-item>
    </el-form>
    <el-table :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }" :data="form.items" size="mini" border style="width: 100%" max-height="600">
      <el-table-column prop="materialCode" :label="$t('wuliaobianma')">
        <template slot-scope="scope">
          <span>{{ scope.row.materialCode }}</span>
          <!-- <el-form-item :prop="'items.' + scope.$index + '.materialCode'" :rules="rules.materialCode">

					</el-form-item> -->
        </template>
      </el-table-column>
      <el-table-column prop="materialName" :label="$t('wuliaomingcheng')">
        <template slot-scope="scope">
          <span>{{ scope.row.materialName }}</span>
          <!-- 	<el-form-item :prop="'items.' + scope.$index + '.materialName'" :rules="rules.materialName">

					</el-form-item> -->
        </template>
      </el-table-column>
      <el-table-column prop="ratio" :label="$t('peifangbili')">
        <template slot-scope="scope">
          <el-input-number :precision="2" :step="0.1" v-model="scope.row.ratio" :controls="false" class="input" @blur="changeWeight(scope.row)"> </el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="weight" :label="$t('peifangyongliaoliang')" :render-header="addRedStar">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.weight" :precision="3" :controls="false" class="input"> </el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="weight" :label="$t('morendanwei')">
        <template slot-scope="scope">
          <span>{{$t(store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][scope.row.defaultUnit])}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('caozuo')">
        <template slot-scope="scope">
          <span style="color:red;" @click="deleteRow(scope.$index, scope.row)">{{ $t('shanchu') }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script type="text/javascript">
import add_material from '@@/pages/web/base/matter/add_material';
export default {
  name: 'web_base_matter_matter_add',
  components: {
    add_material
  },
  data() {
    return {
      key: 0,
      materialList: [],
      form: {
        name: '',
        items: []
      },
      rules: {
        materialCode: [
          {
            required: true,
            message: this.$t('wuliaobianmabunengweikong'),
            trigger: 'blur'
          }
        ],
        materialName: [
          {
            required: true,
            message: this.$t('wuliaomingchengbunengweikong'),
            trigger: 'blur'
          }
        ],
        ratio: [
          {
            required: true,
            message: this.$t('peifangbili(%)bunengweikong'),
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('wuliaobommingchengbunengweikong'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  props: {
    matterRow: {
      type: [Object]
    }
  },
  methods: {
    changeWeight(row) {
      if (!this.matterRow.netWeight) {
        this.matterRow.netWeight = 0;
      }
      if (!row.ratio) {
        row.ratio = 0;
      }
      row.weight = ((row.ratio * this.matterRow.netWeight) / 100).toFixed(3);
    },
    addRedStar(h, { column }) {
      // 给表头加必选标识
      return [
        h(
          'span',
          {
            style: 'color: red'
          },
          '*'
        ),
        h('span', ' ' + column.label)
      ];
    },
    // 删除行
    deleteRow(index, row) {
      this.form.items.splice(index, 1);
      this.utils.successMessage(this.$t('chenggong'));
    },
    // 获取选中数据
    getItems(checks) {
      for (let i = 0; i < checks.length; i++) {
        console.log('ddddd', checks);
        const res = this.form.items.filter(item => {
          return item.materialId === checks[i]['id'];
        });
        if (res.length > 0) {
          continue;
        }
        const item = {
          materialId: checks[i]['id'],
          materialName: checks[i]['name'],
          materialCode: checks[i]['code'],
          defaultUnit: checks[i]['defaultUnit'],
          ratio: 0,
          inputWeight: 0
        };
        console.log('cccjjjjj', item);
        this.form.items.push(item);
      }
      ++this.key;
      this.materialList = [];
    }
  }
};
</script>

<style scoped lang="scss">
.dialog /deep/ .el-dialog__body {
  overflow: auto;
}

.input /deep/ .el-input__inner {
  width: 120px;
}

.input1 /deep/ .el-input__inner {
  width: 220px;
}
</style>
